
export const POR_TELEFONO = ["whatsapp", "whatsapp_cloud"];

export const CANAL = {
  whatsapp: {
    nombre: "WhatsApp",
    color: "#25d366"
  },
  whatsapp_cloud: {
    nombre: "WhatsApp Cloud",
    color: "#25d3c1"
  }
};

export const esTelefono = (valor) => {
  const digitos = String(valor ?? "").replace(/[^0-9]/g, "");
  return digitos.length >= 8 && digitos.length <= 15;
};

export const lineasParaSeguir = ({
  whatsApps = [],
  misColas = [],
  telefono,
  actualId,
  queueId
}) => {
  if (!esTelefono(telefono)) return [];

  const sirve = (w) => {
    if (String(w.id) === String(actualId ?? "")) return false;

    if (!POR_TELEFONO.includes(w.channel)) return false;
    if (w.status !== "CONNECTED") return false;

    if (misColas.length > 0) {
      const colas = (w.queues || []).map((q) => q.id);

      if (!colas.some((id) => misColas.includes(id))) return false;
    }

    return true;
  };

  const puntos = (w) => {
    const colas = (w.queues || []).map((q) => q.id);

    if (queueId && colas.includes(queueId)) return 0;
    if (w.isDefault) return 1;

    return 2;
  };

  return whatsApps
    .filter(sirve)
    .sort(
      (a, b) =>
        puntos(a) - puntos(b) ||
        String(a.name ?? "").localeCompare(String(b.name ?? ""))
    );
};
